{
  "MainTitleAdd": "Add Central Management Environment",
  "MainTitleModify": "Modify Central Management Environment",
  "DomainsTitle": "Domain Profile",
  "ProvisioningTitle": "Provisioning",
  "CapabilitiesTitle": "Capabilities",
  "EstateTitle": "Estate",
  "BrandingTitle": "Branding",
  "LicenseManagementTitle": "Licence Management",
  "CME_AdvancedTabTitle": "Advanced",
  "UnknownDescription": "[Unknown Description]",
  "LanguageCME_ButtonHelpLabel": "Help?",
  "LanguageCME_ButtonSubmitLabel": "OK",
  "LanguageCME_ButtonCancelLabel": "Cancel",
  "LanguageCME_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
  "LanguageCME_PromptConfirm": "Yes",
  "LanguageCME_PromptCancel": "Cancel",
  "LanguageCME_DetailsTitle": "CME Details",
  "CME_Fields_RecursiveRealTimeBots": "Enable/Disable Real-Time for all Tel Servers",
  "CME_EnableVoiceAppBots": "Start Real-Time Queues for {} Tel Servers",
  "CME_EnableVoiceAppBots_Recursive": "Start Real-Time Queues for all Tel Servers",
  "CME_DisableVoiceAppBots": "Stop Real-Time Queues for {} Tel Servers",
  "CME_DisableVoiceAppBots_Recursive": "Stop Real-Time Queues for all Tel Servers",
  "CME_EnableVoiceAppBots_Confirmation_Title": "Please be advised that triggering this option may lead to functionality deterioration within the tenant. This option should only be utilised after consulting with our support team.",
  "NAME": "LanguageCME"
}